module.exports = __webpack_public_path__ + "static/media/icon-white-rental-app.2ee95dae.svg";